import styles from './Title.css';

export function Title({ text }: { text: string }): JSX.Element {
  return (
    <h2 className={styles['title']} data-testid="card.title">
      {text}
    </h2>
  );
}
